import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { AccountService } from '../../../../../services/account.service';
import { DOCUMENT } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-paytm-verify-dialog',
  templateUrl: './paytm-verify-dialog.component.html',
  styleUrls: ['./paytm-verify-dialog.component.css']
})
export class PaytmVerifyDialogComponent implements OnInit {
  payTmVerified = false;
  api_success: string;
  api_error: any; toggleValue: any;
  response: any;
  reshtml: any;

  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService,
  private elementRef: ElementRef,   @Inject(DOCUMENT) public document ) { }

  ngOnInit() {
    this.payTmVerified = this.data.paytm;
  }
changePaytmStatus() {
  this.payTmVerified = !this.payTmVerified;

}
paytmVerify() {
//   this.api_error = '';
//   this.accountService.setPaytmStatus(this.data.accountId, this.payTmVerified)

//     .subscribe(
//       data => {
//         this.response = data;
//         alert(JSON.stringify(this.response));
//         this.reshtml = this.response.response;
//         console.log(JSON.stringify(this.reshtml));
//         const d1 = this.elementRef.nativeElement.querySelector('.result');
//         d1.insertAdjacentHTML('beforeend', this.reshtml);
//         setTimeout(() => {
//           this.document.getElementById('paytmform').submit();
//         }, 500);
//       },
//      (error) => {
//       this.api_error = error.error;
//       }
//     );

}

}
